<material-navbar
  [transparent]="true"
  [container]="true"
  [menuPosition]="
    settings.get('vebto.navbar.defaultPosition', 'homepage-navbar')
  "
  class="login-button-accent"
></material-navbar>
<div class="container container-class" >
  <div class="box">
    <p class="head">Improve links shortening with JioSh URL button</p>
    <p class="sub-head">
      Drag the button to your browser’s toolbar and start to use it just like
      that.
      <br />
      Now when browsing any websites, whenever you click on the "JioSh URL"
      button, you will shorten and simplify it’s url using JioSh - free custom
      URL Shortener.
    </p>

    <p class="drag">Drag it to your browser’s toolbar</p>
    <button mat-raised-button>
      <a style="color: white" href="https://jio.sh"
        ><i class="fa fa-link"></i> Jio.Sh</a
      >
    </button>
  </div>
</div>
<app-footer></app-footer>
